import { ROUTES } from '@/constants'
import { useDeepBoxDeepBoxesBoxesNodesStore } from '@/stores/deepbox/deepboxes/boxes/nodes'
import { useDeepBoxPreviewStore } from '@/stores/deepbox/deepboxes/preview'
import { useDeepBoxSearchStore } from '@/stores/deepbox/search.ts'
import type { Node } from '@deepcloud/api-deep-box'
import type { RouteLocation } from 'vue-router'

export function useNode() {
  const deepBoxDeepBoxesBoxesNodesStore = useDeepBoxDeepBoxesBoxesNodesStore()

  function getCurrentRootNodeFromRoute(currentRoute: RouteLocation) {
    if (
      [
        ROUTES.ROUTE_QUEUE,
        ROUTES.ROUTE_FILES,
        ROUTES.ROUTE_FILES_NODE,
        ROUTES.ROUTE_TRASH,
        ROUTES.ROUTE_TRASH_NODE,
      ].includes(currentRoute.name as string)
    ) {
      return deepBoxDeepBoxesBoxesNodesStore.getCurrentRootNode
    }

    return null
  }

  function getNodeById(nodeId: string) {
    let foundNode
    foundNode = deepBoxDeepBoxesBoxesNodesStore.data?.nodes?.find(
      (node: Node) => node.nodeId === nodeId,
    )

    if (foundNode) {
      return foundNode
    }

    // When not in one of the previous sections search in preview store
    const deepBoxPreviewStore = useDeepBoxPreviewStore()
    foundNode = deepBoxPreviewStore.parentNodeChildren?.nodes?.find(
      (node) => node.nodeId === nodeId,
    )

    if (foundNode) {
      return foundNode
    }

    // When not found anywhere else, look in the search results
    const deepBoxSearchStore = useDeepBoxSearchStore()
    foundNode = deepBoxSearchStore.searchResults?.items?.find(
      (item) => item.nodeId === nodeId,
    )

    if (foundNode) {
      return foundNode
    }

    return null
  }

  return {
    getCurrentRootNodeFromRoute,
    getNodeById,
  }
}
